module.exports = __webpack_public_path__ + "img/wedcr2.e8577fa3.jpg";